export default "__VITE_ASSET__112886cc__"